import { WMICApplicationUtil, APP_NAMES } from 'wmic-portals-utils-js';

import appConfig from 'app-config';

function ensureSingleTrailingSlash(url) {
    if (!url || typeof url !== 'string') {
        return '';
    }
    return `${url}/`.replace(/(\/){2,}$/, '/');
}

function transformServiceNameWmic(serviceName) {
    let appName;
    try {
        appName = WMICApplicationUtil.getAppName();
    } catch (error) {
        appName = undefined;
    }
    let edgeVariant = '';
    switch (appName) {
        case APP_NAMES.CE:
        case APP_NAMES.AMP:
            edgeVariant = 'US';
            break;
        case APP_NAMES.PE:
            edgeVariant = 'CA';
            break;
        default:
            console.debug('Unknown application name. it is expected for PE and thus can be ignored');
            break;
    }
    return serviceName + edgeVariant;
}

/**
 * Returns the Real service url (not proxied)
 * @param {string} serviceName the name of the service to invoke
 *                  (the service name is defined in the ServiceEnpoint of each capability)
 * @returns {string} the real service url
 */
export function getProxiedServiceUrl(serviceName) {
    const { capabilities } = appConfig;
    const { env } = appConfig;
    const transformedServiceName = transformServiceNameWmic(serviceName);
    const endpoint = capabilities[transformedServiceName] || capabilities[serviceName];
    const baseUrl = ensureSingleTrailingSlash(env.API_GATEWAY_URL);

    if (!endpoint) {
        return null;
    }

    if (!baseUrl) {
        return endpoint.service;
    }

    return baseUrl + endpoint.service;
}

/**
 * Returns the direct claims service url built from CLAIMS_URL config.
 * Used for all claim, FNOL, and claim-document capabilities that bypass
 * the edge API gateway and call ClaimCenter directly with an Okta bearer token.
 *
 * @param {string} serviceName the name of the service (matches serviceName in ServiceEndpoints.json)
 * @returns {string|null} the direct claims url, or null if CLAIMS_URL is not configured
 */
export function getClaimsDirectUrl(serviceName) {
    const { serviceUrls, capabilities } = appConfig;
    const claimsEndpoint = serviceUrls && serviceUrls.claimsEndpoint;

    if (!claimsEndpoint || claimsEndpoint.includes('{{')) {
        return null;
    }

    const transformedServiceName = transformServiceNameWmic(serviceName);
    const endpoint = capabilities[transformedServiceName] || capabilities[serviceName];

    if (!endpoint) {
        return null;
    }

    return ensureSingleTrailingSlash(claimsEndpoint) + endpoint.service;
}

/**
 * Returns a url which will be proxied depending on the base url
 *
 * This is generally meant for *non-EDGE* URLs.
 * If you you want to proxy an edge capability, you should probably use
 * `getProxiedServiceUrl`
 *
 * @see {@link getProxiedServiceUrl}
 * @param {string} urlToProxy the url that should be proxied
 * @returns {string} the real url which accounts for the deployment url
 */
export function getProxiedUrl(urlToProxy) {
    if (!urlToProxy) {
        return null;
    }

    const { env } = appConfig;
    const baseUrl = ensureSingleTrailingSlash(env.API_GATEWAY_URL);

    if (!baseUrl) {
        return urlToProxy;
    }

    return baseUrl + urlToProxy;
}
